/* eslint-disable */
import { defineStore } from 'pinia';
import axios from 'axios';
import { useLanguagesStore } from './languages';
import { useCustomerStore } from './customer';

export const useHorseRacingStore = defineStore('horseRacing', {
	state: () => ({
		callback_url: null,
		loading: false,
		error: null,
		is_open: false,
	}),
	getters: {
		callbackUrl(state) {
			return state.callback_url;
		},
		isLoading(state) {
			return state.loading;
		},
		hasError(state) {
			return state.error !== null;
		},
		errorMessage(state) {
			return state.error;
		},
		isOpen(state) {
			return state.is_open;
		},
		getLanguage() {
			const languagesStore = useLanguagesStore();
			const locale = languagesStore.selectedLanguage?.locale || 'en';

			// Map locale to TripleApuesta supported languages (en, es, pt)
			const languageMap = {
				'en': 'en',
				'es': 'es',
				'pt': 'pt',
				'pt-br': 'pt',
			};

			return languageMap[locale] || 'en';
		},
		iframeUrl(state) {
			if (!state.callback_url) return null;

			const language = this.getLanguage;
			const homeUrl = 'https://www.24vamos.com';
			const url = new URL(state.callback_url);

			url.searchParams.set('language', language);
			url.searchParams.set('homeURL', homeUrl);

			return url.toString();
		}
	},
	actions: {
		async login() {
			const customerStore = useCustomerStore();

			if (!customerStore.customer) {
				this.error = 'You must be logged in to play Horse Racing';
				return false;
			}

			this.loading = true;
			this.error = null;

			try {
				// global.axios already has Authorization header set from main.js
				const response = await global.axios.post(process.env.VUE_APP_API_URL + '/horse-racing/login');

				if (response.data && response.data.callbackUrl) {
					this.callback_url = response.data.callbackUrl;
					this.is_open = true;
					return true;
				} else {
					this.error = 'Failed to get game URL';
					return false;
				}
			} catch (error) {
				console.error('Horse Racing login error:', error);

				if (error.response?.status === 401) {
					this.error = 'Session expired. Please login again.';
				} else if (error.response?.data?.error) {
					this.error = error.response.data.error;
				} else {
					this.error = 'Failed to connect to Horse Racing. Please try again.';
				}

				return false;
			} finally {
				this.loading = false;
			}
		},

		open() {
			this.is_open = true;
		},

		close() {
			this.is_open = false;
		},

		reset() {
			this.callback_url = null;
			this.loading = false;
			this.error = null;
			this.is_open = false;
		}
	}
});
